import { Col, Row, Typography } from "antd";
import ManifestImageComponent from "./ManifestImageComponent";

const { Title } = Typography;
const ImageRenderComponent = ({ list = [], label = '' }: { list: unknown[] | undefined | unknown, label: string | undefined }) => {
    return (
        <>
            {
                (Array.isArray(list) && list?.length) ?
                    <>
                        <Row wrap justify="start">
                            <Col span={24}>
                                <Title type="secondary" level={5} underline>{label}</Title>
                            </Col>
                            <ManifestImageComponent list={list} />
                        </Row>
                    </>
                    : null
            }
        </>

    )
}
export default ImageRenderComponent